import { StrapiComponentType } from "../type";
import { FormItemDefinedPropertyType } from "../type/strapi/collection";
import { TimeHelper } from "../util";

export type FormPropertyType = {
  property: string;
  value: any;
  syncToCRM?: string;
  crmPropertyName?: string;
};

export type DataObject = {
  id?: number;
  data: any;
  lastResponse?: any;
};

export function getIsSpecialProperty(property: string) {
  return Object.values(FormItemDefinedPropertyType).includes(property as FormItemDefinedPropertyType);
}

export function getFormItem(propertyName: string, currentStep: number, form?: StrapiComponentType.Section.DynamicForm) {
  const currentStepItems = form?.steps?.[currentStep]?.form_items?.data ?? [];
  const formItem = currentStepItems?.find((item) => item.attributes.definedProperty ?? item.attributes.jsonPropertyName === propertyName);
  return formItem;
}

export function updateFormProperty({
  propertyName,
  formProperties,
  value,
  currentStep,
  form,
}: {
  propertyName: string;
  formProperties: FormPropertyType[];
  value: any;
  currentStep: number;
  form?: StrapiComponentType.Section.DynamicForm;
}) {
  const formProperty = formProperties.find((property) => property.property === propertyName);
  const formItem = getFormItem(propertyName, currentStep, form);
  const _value =
    formItem?.attributes.type === "DatePicker" && value ? TimeHelper.timeToMidnightUTC(new Date(value).toISOString()) : value ? `${value}` : "";

  if (formItem?.attributes.type) {
    if (formProperty) {
      formProperty.value = _value;
    } else {
      formProperties.push({
        property: propertyName,
        value: _value,
        syncToCRM: "false",
        crmPropertyName: formItem.attributes.crmPropertyName,
      });
    }
  }
}

export function createDataObjectData({
  formData,
  dataObject,
  currentStep,
  form,
}: {
  formData: Record<string, any>;
  dataObject: DataObject | undefined;
  currentStep: number;
  form?: StrapiComponentType.Section.DynamicForm;
}) {
  const formProperties: FormPropertyType[] = [];
  const data: Record<string, any> = dataObject?.data ?? { formProperties: formProperties };
  Object.entries(formData).forEach(([key, value]) => {
    if (getIsSpecialProperty(key)) {
      data[key] = value ?? "";
    } else {
      updateFormProperty({ propertyName: key, formProperties: data.formProperties, value, currentStep, form });
    }
  });
  return data;
}
